import { render, staticRenderFns } from "./_EditManifestCustomLabelDialog.vue?vue&type=template&id=6e6caf8e&scoped=true&"
import script from "./_EditManifestCustomLabelDialog.vue?vue&type=script&lang=js&"
export * from "./_EditManifestCustomLabelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6caf8e",
  null
  
)

export default component.exports